import angular from 'angular';

import ConfirmModalComponent from './confirm-modal.cmpt';

export default angular
    .module('application.component.modals.component.confirm-modal', [])
    .component(ConfirmModalComponent.selector, ConfirmModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/confirm-modal/index.js